import React from 'react';
import {
  CustomTooltipWrapper,
  TooltipWrapper,
  TooltipContentWrapper,
} from '@components/userDocuments/editDocument/editResume/EditSpace/EditorPane/Pad/ExpertTips/Shared/styles';
import { useOverflow } from './useTooltip';

interface TooltipContentProps {
  content: React.ReactNode;
  showTooltip?: boolean | undefined;
  tooltipContent?: React.ReactNode;
}

export const TooltipContent: React.FC<TooltipContentProps> = ({
  content,
  showTooltip,
  tooltipContent,
}) => {
  const { ref, isOverflowing } = useOverflow(content);

  if (showTooltip && isOverflowing) {
    return (
      <CustomTooltipWrapper
        placement="left"
        showArrow
        classNames={{
          base: ['before:bg-black dark:before:bg-white', 'mr-[10px]'],
        }}
        content={<TooltipWrapper>{tooltipContent || content}</TooltipWrapper>}
      >
        <TooltipContentWrapper ref={ref}>{content}</TooltipContentWrapper>
      </CustomTooltipWrapper>
    );
  }
  return <TooltipContentWrapper ref={ref}>{content}</TooltipContentWrapper>;
};

TooltipContent.defaultProps = {
  showTooltip: false,
  tooltipContent: null,
};
